const API_BASE = import.meta.env.VITE_API_BASE ?? ''

/** URL for viewing/downloading an SOP's attached PDF. Visibility (draft
 *  vs published) is enforced server-side same as the rest of the API. */
export function sopDownloadUrl(id: string): string {
  return `${API_BASE}/api/sop-library/${id}/download`
}
